module.exports = __webpack_public_path__ + "static/media/headshot_carly.c6a33c94.png";